import { MOBLY, TOKSTOK, SUPPORT } from '@/utils/possible-organizations-values'

const THEMES = {
  [MOBLY]: {
    default: '#FF4600',
    dark: '#B53200',
    light: '#FF723D'
  },
  [TOKSTOK]: {
    default: '#0a775a',
    dark: '#129975',
    light: '#09644c'
  },
  [SUPPORT]: {
    default: '#0c0c0c',
    dark: '#000000',
    light: '#1d1d1d'
  }
}

export const setTheme = (organization) => {
  const theme = THEMES[organization] || THEMES[MOBLY]
  const root = document.documentElement

  root.style.setProperty('--color-primary-default', theme.default)
  root.style.setProperty('--color-primary-dark', theme.dark)
  root.style.setProperty('--color-primary-light', theme.light)
}
